import { useAtom } from "jotai";
import type { JSX } from "react";

import { HoursField } from "@frontend/shared/hours-field";
import { Trans } from "@lingui/react/macro";

import type { TaskFields } from "./TaskDialog";

export type TaskHoursProps = {
  field: TaskFields["hours"];
};

export function TaskHours({ field }: TaskHoursProps): JSX.Element {
  const [rows, setRows] = useAtom(field.valueAtom);

  return (
    <HoursField
      rows={rows}
      onRowsChange={setRows}
      create={({ begin, end }) => ({ id: null, begin, end, statusId: null })}
      hint={<Trans>No range yet.</Trans>}
    />
  );
}
